<template>
  <div class="lianjie">
    <div class="lxbk">
      <div class="lx">
        <div>相关链接：</div>
        <p><a href="http://www.guanghangroup.com">广瀚集团</a></p>
        <p><a href="http://3d.sanweiquan.cn">三维圈数科集团</a></p>
        <p>
          <a href="http://app.youtixijiaoyu.com">三维圈|数字化赋能教育发展</a>
        </p>
        <p>大疆创新</p>
      </div>
    </div>
    <div class="bt">
      <div class="yb">
        <div class="yb_l">
          <div class="p2">
            <img src="../image/logo-index .png" alt="" class="bt_log" />
            <span>无人机数字化智慧工场</span>
          </div>
          <p>公司地址：河南省郑州市金水区杨金路199号新科技市场9号楼4层</p>
          <p>联系电话：15036062166</p>
        </div>
        <div class="yb_r" style="display: flex; margin-left: 100px">
          <div style="margin-right: 20px">
            <img src="../image/erweima.jpg" alt="" class="em" />
            <p>微信公众号</p>
          </div>
          <div>
            <img src="../image/chengxu.jpg" alt="" class="em" />
            <p>微信小程序</p>
          </div>
        </div>
      </div>
      <div class="bt_xian"></div>
      <ul class="botom_slider">
        <li @click="btcomnt('/homePage')">首页 <a>|</a></li>
        <li @click="btcomnt('/onlinecourse')">在线课程 <a>|</a></li>
        <li @click="btcomnt('/training')">证书培训 <a>|</a></li>
        <li @click="btcomnt('/guidance')">竞赛指导 <a>|</a></li>
        <li >实训模拟 <a>|</a></li>
        <li @click="btcomnt('/findjob')">就业创业 <a>|</a></li>
        <li @click="btcomnt('/news')">新闻资讯 <a>|</a></li>
        <li @click="btcomnt('/contactUs')">联系我们</li>
      </ul>
      <div style="color: #aaaaaa; margin-top: 10px; background: #303030;text-align:center">
        <a href="https://beian.miit.gov.cn/" target="_blank" class="beianhao">
          @优体希教育-优体希教育集团.版权所有 备案号：豫ICP备2020030466号-2</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "bottom",
  methods: {
    btcomnt(e) {
      this.$router.push(e);
      this.$store.commit("CHANGE_PAGE", e);
    },
  },
};
</script>
<style>
.lianjie {
  background: #303030;
  color: #fff;
  border: none;
}
.lxbk {
  min-width: 1200px;
  width: 100%;
  height: 48px;
  margin: 0 auto;
  background: #2c2c2c;
  border: none;
}
.lx {
  width: 1200px;
  height: 48px;

  margin: 0 auto;
  display: flex;
  align-items: center;
}
.lx div {
  margin-right: 50px;
}
.lx p {
  margin-right: 50px;
}
.lx p a {
  text-decoration: none;
  color: #fff;
}
.bt {
  width: 1200px;
  margin: 0 auto;
  height: 262px;
  background: #303030;
}
.yb {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.yb_l {
  width: 900px;
}
.yb_l p {
  text-align: left;
  color: #aaaaaa;
  padding-bottom: 15px;
}
.p2 {
  display: flex;
  align-items: center;
  margin: 20px 0px;
}
.yb_l span {
  height: 29px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 26px;
}
.bt_xian {
  min-width: 1200px;
  width: 1200px;
  height: 1px;
  background: #626262;
  margin: 0 auto;
}
/* autoresize */
.bt_log {
  width: 56px;
  height: 56px;
  margin-right: 9px;
}

.em {
  width: 80px;
  height: 80px;
}
.botom_slider {
  width: 880px;
  margin: 0 auto;
  display: flex;
  margin-top: 20px;
}
.botom_slider li {
  cursor: pointer;
}
.botom_slider a {
  padding: 0 20px;
}
.beianhao {
  color: #ffffff;
  text-decoration: none;
}
</style>